import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  typographyRoot: {
    position: 'absolute',
  },
});

const TextOverlay = ({ children, text, textProps = {}, containerProps = {} }) => {
  const { classes } = useStyles();
  return (
    <Box
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...containerProps}
    >
      {children}
      <Typography classes={{ root: classes.typographyRoot }} {...textProps}>
        {text}
      </Typography>
    </Box>
  );
};

TextOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  textProps: PropTypes.object,
};



export default TextOverlay;
